angular.module('rjmNg.directives').directive 'renderHighchart', [
  "chartFormatterService"
  "figureService"
  "app"
  "utils"
  "dateService"
  "colorThemeService"
  "SCATTER_PLOT_POINTS_ENUMS"
  "HEAT_MAP_ENUMS"
  'timeRangeEnums'
  (
    chartFormatterService
    figureService
    app
    utils
    dateService
    colorThemeService
    SCATTER_PLOT_POINTS_ENUMS
    HEAT_MAP_ENUMS
    timeRangeEnums
  ) ->
    restrict: "E"
    template: "<div style='padding-top:0px;' class='figure-content-highchart chartContainer'></div>"
    replace: true
    scope: true
    priority: 300
    require: "^figure"
    controller: [
      "$scope"
      "$element"
      "reportQueryType"
      (
        $scope
        $element
        reportQueryType
      ) ->

        $scope.reportQueryType = reportQueryType

        _getHighchart = () ->
          $element.highcharts()

        # In the event that we have a resizeFigurePresentation
        # directive, that directive can use this function.
        @resizeFunction = (width, height) ->
          _getHighchart()?.setSize(width, height, false)

        @
    ]
    link: (scope, elem, attrs, controller) ->
      # We don't need to assign the figure controller to
      # a variable because we only require it to ensure
      # that every element with a renderHighchart directive
      # has a figureDirective parent.

      # Determines whether series names are longer than chart width
      _containsLongNames = (highchart) ->
        if highchart.chart.type in ['bar', 'pie', 'funnel']
          return false

        yAxisWidth = 50
        approxWidthOneChar = 6

        allSeries = highchart.series
        if not allSeries? or allSeries.length < 1
          return false
        allNames = (series.name for series in allSeries)
        allNames = allNames.join(' ')
        yAxesWidth = if highchart.yAxis?.length then highchart.yAxis.length * yAxisWidth else yAxisWidth
        if allNames.length * approxWidthOneChar > (elem[0]?.offsetWidth - yAxesWidth) # Heuristic for longness
          return true
        else
          return false

      # Creates the legend object that will be part of the highchart
      _genLegend = (highchart) ->
        # Disable the legend if one or fewer series are present
        if (highchart.chart.legend?.enabled? and not highchart.chart.legend.enabled) or not highchart.series? or highchart.series?.length <= 1
          return { enabled: false }

        legend = {}
        # Determine whether or not a chart contains long series names--
        # if so, put the legend below the Highchart
        if _containsLongNames(highchart)
          legend.align = 'center'
          legend.verticalAlign = 'bottom'
          legend.floating = false
        else if highchart.series?.length > 5
          legend.layout = 'vertical'
          legend.align = 'right'
          legend.verticalAlign = 'top'
          legend.x = -15
          legend.y = 10
          legend.floating = false
          legend.width = 150
          legend.itemMarginTop = 3
        else
          legend.align = 'left'
          legend.verticalAlign = 'top'
          legend.y = -30
          legend.x = 0
          legend.floating = true

        return legend

      # Creates the HeatMap legend object that will be part of the highchart
      _genHeatMapLegend = (highchart) ->
        legend = {}
        # Logic to determine if legend should be enabled or not
        if (highchart.chart.legend?.enabled? and not highchart.chart.legend.enabled) or not highchart.series?
          return { enabled: false }
        else
          legend.layout = 'vertical'
          legend.align = 'right'
          legend.verticalAlign = 'top'
          legend.x = -15
          legend.y = -3
          legend.floating = false
          legend.width = 150
          legend.symbolHeight = 240
        return legend

      _getColumns = (figure) ->
        return figure.data?.columns 

      _genXAxis = (highchart, figure) ->
        type: 'datetime'
        categories: highchart.xAxis?.categories ?= 'Figure Values'
        dateTimeLabelFormats: # I don't think this works at all
          day: '%Y-%m-%d'
        labels:
          rotation: 0
          overflow: 'justify'
          align: chartFormatterService.getXAxisLabelAlignment(highchart.chart.type)
          step: chartFormatterService.getStep(highchart.chart.type, highchart.xAxis?.categories, elem[0]?.offsetWidth, highchart.yAxis?.length)
          y: chartFormatterService.getXAxisLabelY(highchart.chart.type)
        tickWidth: 1
      
      _genHeatMapColorAxis = () ->
        min: null # when null, the min value is automatically calculated
        minColor: HEAT_MAP_ENUMS.MIN_COLOR
        maxColor: HEAT_MAP_ENUMS.MAX_COLOR

      # _getHeatMapDataSet() is used in the formatter() below to calculate the correct dataset
      # for Heatmap charts that have one Group By and Time Interval set.
      #
      # This function will take two arguments: 'valueData', 'xData'
      #
      # NOTE: The indexed positions of 'valueData' and 'xData' values are
      #       a direct match of one another.
      #
      #       Arrays 'valueData' and 'xData' are highchart's series properties that store all
      #       data point values and x-indices(the x-indices are indices of the date time values
      #       for whichever Time Interval is selected)
      #
      # This function will return the first column of values in the
      # Heatmap chart at the zero index of the xAxis
      #
      #       - chart representation = [[50,20,25]
      #                                 [10,30,45]
      #                                 [15,35,65]]
      #
      #       - valueData = [15,35,65,10,30,45,50,20,25]
      #       - xData = [0,1,2,0,1,2,0,1,2]
      #       - Given: _getHeatMapDataSet(allHeatMapValues, allYIndices)
      #       - Result: [50, 10, 15]
      _getHeatMapDataSet = (allHeatMapValues, allXIndices) ->
        dataset = []
        for v, i in allXIndices
          if v is 0
            dataset.push(allHeatMapValues[i])
        return dataset

      # Takes a look at the chart object passed in and returns a new
      # object with any needed properties that weren't set
      _genBasicOptions = (highchart, figure, exporting = false) ->
        isScatterChart = figureService.getChartTypeFromFigure(figure) in ['scatter', 'scattertrendline']
        isHeatMap = figureService.getChartTypeFromFigure(figure) is 'heatmap'

        chart:
          type: highchart.chart?.type ?= 'line'
          zoomType: 'xy'
          spacingTop: if (highchart.chart.legend?.enabled? and not highchart.chart.legend.enabled) or highchart.series?.length <= 1 or highchart.series?.length > 5 then 15 else 35
          backgroundColor: if exporting then 'white' else 'transparent'

        legend: if isHeatMap then _genHeatMapLegend(highchart) else _genLegend(highchart)
        plotOptions:
          area:
            stacking: highchart.plotOptions?.area?.stacking
            marker:
              enabled: _getColumns(figure).length is 1
          line:
            marker:
              enabled:  _getColumns(figure).length is 1
          column:
            stacking: highchart.plotOptions?.column?.stacking
            pointPadding: 0.05
            groupPadding: 0
          bar:
            stacking: highchart.plotOptions?.bar?.stacking
            pointPadding: 0.06
            groupPadding: 0
          scatter:
            radius: 6


        exporting:
          url: '../exporting-server/'
          enabled: exporting
          sourceWidth: elem[0].offsetWidth
          sourceHeight: elem[0].offsetHeight
          buttons:
            contextButton:
              menuItems: [
                'printChart'
                'separator'
                'downloadPNG'
                'downloadPDF'
                'downloadSVG'
              ]

        series: highchart.series ?= null

        xAxis: if isScatterChart then figureService.genAxisOptions(figure, highchart, "xAxis") else _genXAxis(highchart, figure)

        yAxis: figureService.genAxisOptions(figure, highchart, "yAxis")
        # Set the zAxis property only if highchart has the same property. This is only used for bubble chart
        zAxis: if highchart.zAxis then figureService.genAxisOptions(figure, highchart, "zAxis") else null
        # Set the colorAxis property only for heat map
        colorAxis: if isHeatMap then _genHeatMapColorAxis() else null

        tooltip:
          shared: false
          followPointer: true
          formatter: () ->
            metricIndex = this.series.index % figureService.getNumberOfMetrics(figure)
            timeInterval = figureService.getTimeInterval(figure)

            # get prefix, suffix, datatype, range and median from the figure data
            [prefix, suffix, dataType, range, median] = figureService.getMeasureDataFromFigureData(figure.data, this.series.yData, metricIndex)

            if highchart.chart.type in ['pie', 'funnel']
              formattedPercentage = _formatPercentage(@.point.percentage)
              "<div class='chartTooltip'>
                <h4>#{this.key}</h4>
                  <span style=\"color:#{this.point.color}\">
                    #{chartFormatterService.getValueAdjustedForDataType(this.y, prefix, suffix, dataType, range, median)}
                  </span> #{formattedPercentage}
              </div>"
            else if @.point.percentage?
              formattedPercentage = _formatPercentage(@.point.percentage)
              "<div class='chartTooltip'>
                <h4>#{this.x}</h4>
                  <span style=\"color:#{this.series.color}\">
                    #{this.series.name.replace( /(<([^>]+)>)/ig, '')}</span> 
                    <strong>#{chartFormatterService.getValueAdjustedForDataType(this.y, prefix, suffix, dataType, range, median)}</strong>
                  <span>#{formattedPercentage}</span>
              </div>"
            else if highchart.chart.type is 'scatter' and figureService.getNumberOfMetrics(figure) is 2
              # Scatter Chart With Trendline
              if this.series.name is 'Average'
                return false
              # Group By Scatter Chart
              else if figure.data.columns[0] is 'Value'
                # get prefix, suffix, datatype, range and median from the figure data
                [prefixX, suffixX, dataTypeX, rangeX, medianX] = figureService.getMeasureDataFromFigureData(figure.data, this.series.xData, 0)
                [prefixY, suffixY, dataTypeY, rangeY, medianY] = figureService.getMeasureDataFromFigureData(figure.data, this.series.yData, 1)

                "<div class='chartTooltip'>
                  <h4>#{this.point.name}</h4>
                    <span style=\"color:#{highchart.xAxis[0].title.style.color}\">
                      #{this.series.chart.options.xAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.x, prefixX, suffixX, dataTypeX, rangeX, medianX)}
                      </strong>
                      <br>
                    <span style=\"color:#{highchart.yAxis[0].title.style.color}\">
                      #{this.series.chart.options.yAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.y, prefixY, suffixY, dataTypeY, rangeY, medianY)}
                      </strong>
                  </div>"
              else
                # get prefix, suffix, datatype, range and median from the figure data
                [prefixX, suffixX, dataTypeX, rangeX, medianX] = figureService.getMeasureDataFromFigureData(figure.data, this.series.xData, 0)
                [prefixY, suffixY, dataTypeY, rangeY, medianY] = figureService.getMeasureDataFromFigureData(figure.data, this.series.yData, 1)

                # Time Interval Scatter Chart
                "<div class='chartTooltip'>
                  <h4>#{dateService.format(this.point.name, timeInterval, true)}</h4>
                    <span style=\"color:#{highchart.xAxis[0].title.style.color}\">
                      #{this.series.chart.options.xAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.x, prefixX, suffixX, dataTypeX, rangeX, medianX)}
                      </strong>
                      <br>
                    <span style=\"color:#{highchart.yAxis[0].title.style.color}\">
                      #{this.series.chart.options.yAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.y, prefixY, suffixY, dataTypeY, rangeY, medianY)}
                      </strong>
                  </div>"
            else if highchart.chart.type is 'scatter' and figureService.getNumberOfMetrics(figure) is 3
              # Bubble Chart With Trendline
              if this.series.name is 'Average'
                return false
              else if highchart.series[0].multiSeries is true and figure.data.columns[0] is 'Value'
                # get prefix, suffix, datatype, range and median from the figure data
                [prefixX, suffixX, dataTypeX, rangeX, medianX] = figureService.getMeasureDataFromFigureData(figure.data, this.series.xData, 0)
                [prefixY, suffixY, dataTypeY, rangeY, medianY] = figureService.getMeasureDataFromFigureData(figure.data, this.series.yData, 1)
                [prefixZ, suffixZ, dataTypeZ, rangeZ, medianZ] = figureService.getMeasureDataFromFigureData(figure.data, this.series.zData, 2)
                # Group By Multi-Series Bubble Chart
                "<div class='chartTooltip'>
                  <h4>
                    #{this.point.name}
                  </br>
                    #{this.point.groupByName}
                  </h4>
                    <span style=\"color:#{highchart.xAxis[0].title.style.color}\">
                      #{this.series.chart.options.xAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.x, prefixX, suffixX, dataTypeX, rangeX, medianX)}
                      </strong>
                      <br>
                    <span style=\"color:#{highchart.yAxis[0].title.style.color}\">
                      #{this.series.chart.options.yAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.y, prefixY, suffixY, dataTypeY, rangeY, medianY)}
                      </strong>
                      <br>
                    <span style=\"color:#{highchart.zAxis[0].title.style.color}\">
                      #{this.series.chart.options.zAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.point.z, prefixZ, suffixZ, dataTypeZ, rangeZ, medianZ)}
                      </strong>
                  </div>"
              else if highchart.series[0].multiSeries is false and figure.data.columns[0] is 'Value'
                # get prefix, suffix, datatype, range and median from the figure data
                [prefixX, suffixX, dataTypeX, rangeX, medianX] = figureService.getMeasureDataFromFigureData(figure.data, this.series.xData, 0)
                [prefixY, suffixY, dataTypeY, rangeY, medianY] = figureService.getMeasureDataFromFigureData(figure.data, this.series.yData, 1)
                [prefixZ, suffixZ, dataTypeZ, rangeZ, medianZ] = figureService.getMeasureDataFromFigureData(figure.data, this.series.zData, 2)

                # Group By Single-Series Bubble Chart
                "<div class='chartTooltip'>
                  <h4>#{this.point.name}</h4>
                    <span style=\"color:#{highchart.xAxis[0].title.style.color}\">
                      #{this.series.chart.options.xAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.x, prefixX, suffixX, dataTypeX, rangeX, medianX)}
                      </strong>
                      <br>
                    <span style=\"color:#{highchart.yAxis[0].title.style.color}\">
                      #{this.series.chart.options.yAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.y, prefixY, suffixY, dataTypeY, rangeY, medianY)}
                      </strong>
                      <br>
                    <span style=\"color:#{highchart.zAxis[0].title.style.color}\">
                      #{this.series.chart.options.zAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.point.z, prefixZ, suffixZ, dataTypeZ, rangeZ, medianZ)}
                      </strong>
                  </div>"
              else
                # get prefix, suffix, datatype, range and median from the figure data
                [prefixX, suffixX, dataTypeX, rangeX, medianX] = figureService.getMeasureDataFromFigureData(figure.data, this.series.xData, 0)
                [prefixY, suffixY, dataTypeY, rangeY, medianY] = figureService.getMeasureDataFromFigureData(figure.data, this.series.yData, 1)
                [prefixZ, suffixZ, dataTypeZ, rangeZ, medianZ] = figureService.getMeasureDataFromFigureData(figure.data, this.series.zData, 2)

                # Time Interval Single-Series Bubble Chart
                "<div class='chartTooltip'>
                  <h4>#{dateService.format(this.point.name, timeInterval, true)}</h4>
                    <span style=\"color:#{highchart.xAxis[0].title.style.color}\">
                      #{this.series.chart.options.xAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.x, prefixX, suffixX, dataTypeX, rangeX, medianX)}
                      </strong>
                      <br>
                    <span style=\"color:#{highchart.yAxis[0].title.style.color}\">
                      #{this.series.chart.options.yAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.y, prefixY, suffixY, dataTypeY, rangeY, medianY)}
                      </strong>
                      <br>
                    <span style=\"color:#{highchart.zAxis[0].title.style.color}\">
                      #{this.series.chart.options.zAxis[0].title.text}
                    </span>
                      <strong>
                        #{chartFormatterService.getValueAdjustedForDataType(this.point.z, prefixZ, suffixZ, dataTypeZ, rangeZ, medianZ)}
                      </strong>
                  </div>"
            else if highchart.chart.type in ['heatmap']
              dateTimeData = figureService.getDateTimeDataForToolTip(figure, this.point.x)

              label =
                # Properties for Heatmap Chart GroupBy Two Columns
                if figureService.getTimeInterval(figure) is timeRangeEnums.TIME_INTERVAL_VALUES.NONE
                  xAxis: figureService.getGroupByHeatMapCategoryNames(figure, 0).reverse()[this.point.y]
                  yAxis: figureService.getGroupByHeatMapCategoryNames(figure, 1)[this.point.x]
                  dataset: this.series.valueData
                else
                # Properties for Heatmap Chart With Time Interval Set
                  xAxis: dateService.format(dateTimeData, timeInterval, true)
                  yAxis: figureService.getTimeIntervalHeatMapCategoryNames(figure).reverse()[this.point.y]
                  dataset: _getHeatMapDataSet(this.series.valueData, this.series.xData)

              # get prefix, suffix, datatype, range and median from the figure data
              [prefix, suffix, dataType, range, median] = figureService.getMeasureDataFromFigureData(figure.data, label.dataset, 0)
              "<div class='chartTooltip'>
                <h4>
                  #{label.xAxis}
                </br>
                  #{label.yAxis}
                </br>
                </h4>
                  <span style=\"color:#{this.series.chart.tooltip.options.style.color}\">
                    #{figureService.getMetricNameForToolTip(figure, 0)}
                  </span>
                  <strong>
                    #{chartFormatterService.getValueAdjustedForDataType(this.point.value, prefix, suffix, dataType, range, median)}
                  </strong>
              </div>"
            else
              "<div class='chartTooltip'>
                <h4>#{this.x}</h4>
                  <span style=\"color:#{this.series.color}\">
                    #{this.series.name.replace( /(<([^>]+)>)/ig, '')}</span> 
                      <strong>#{chartFormatterService.getValueAdjustedForDataType(this.y, prefix, suffix, dataType, range, median)}</strong>
                      </div>"

      _formatPercentage = (value) ->
        return value.toFixed(2) + "%"

      _modifyHeatMapAxes = (modifiedChart) ->
        modifiedChart.xAxis.labels =
          # To show only every n'th label on the axis, set the step to n.
          step: 1
        if modifiedChart.xAxis.categories?
          # the _genXAxis() sets the type to "datetime" be default
          # We want to modify and set the type here to "category"
          modifiedChart.xAxis.type = "category"

      _modifyHeatMapSeries = (series, figure) ->
        series.borderWidth = HEAT_MAP_ENUMS.BORDER_WIDTH
        series.borderColor = HEAT_MAP_ENUMS.BORDER_COLOR
        series.lineWidth = HEAT_MAP_ENUMS.LINE_WIDTH
        series.nullColor = HEAT_MAP_ENUMS.NULL_COLOR
        series.dataLabels =
          enabled: true
          color: HEAT_MAP_ENUMS.DATA_LABEL_COLOR
          style:
            fontSize: HEAT_MAP_ENUMS.FONT_SIZE
            textShadow: HEAT_MAP_ENUMS.TEXT_SHADOW
          formatter: () ->
            dataset =
              if figureService.getTimeInterval(figure) is timeRangeEnums.TIME_INTERVAL_VALUES.NONE\
              then this.series.valueData\
              else _getHeatMapDataSet(this.series.valueData, this.series.xData)

            [prefix, suffix, dataType, range, median] = figureService.getMeasureDataFromFigureData(figure.data, dataset, 0)
            "<span>
              #{chartFormatterService.getValueAdjustedForDataType(this.point.value, prefix, suffix, dataType, range, median)}
            </span>
            "

      _modifyScatterSeries = (series, figure) ->
        if series.type is 'scatter' or 'bubble'
          series.marker.radius = SCATTER_PLOT_POINTS_ENUMS.RADIUS
          series.marker.lineWidth = SCATTER_PLOT_POINTS_ENUMS.LINE_WIDTH
          if figureService.getNumberOfGroupings(figure) is 2
            series.marker.fillColor = null
          else
            series.marker.fillColor = SCATTER_PLOT_POINTS_ENUMS.FILL_COLOR
        # styles for trendline
        if series.type is 'line'
          series.marker.radius = SCATTER_PLOT_POINTS_ENUMS.TREND_LINE_RADUIS
          series.color = SCATTER_PLOT_POINTS_ENUMS.TREND_LINE_SERIES_COLOR

      # Loop through the series and make any conditional changes we need to make
      _modifySeries = (highchart, figure) ->
        modifiedChart = utils.copy(highchart)
        if modifiedChart.chart.type is 'heatmap' 
          modifiedChart.yAxis.categories.reverse()
          if figure.data.columns[0] is 'Value'
            _modifyHeatMapAxes(modifiedChart)

        for id, series of modifiedChart.series
          if app.hasFeatureFlag('UNIQUE_SERIES_COLORS')
            series.color = chartFormatterService.getColorByString(series.name)
          else
            if modifiedChart.chart.type in ['pie', 'funnel']
              series.colors = colorThemeService.getColors()
            else if modifiedChart.chart.type in ['scatter', 'scattertrendline']
              series.color = colorThemeService.pickColorForScatterplotTypeSeries(id)
            else
              series.color = colorThemeService.pickColor(id)
          
          if modifiedChart.chart.type is 'heatmap'
              _modifyHeatMapSeries(series, figure)
          series.marker = chartFormatterService.setMarkers(series, highchart.chart.type)
          
          if modifiedChart.chart.type is 'scatter'
            _modifyScatterSeries(series, figure)

        if modifiedChart.chart.type in ['scatter', 'scattertrendline']
          modifiedChart.xAxis[0].labels.step = SCATTER_PLOT_POINTS_ENUMS.STEP
        return modifiedChart

      _assignAxes = (figure) ->
        figureObject = figure.presentation.highcharts.chart
        if figureService.getChartTypeFromFigure(figure) in ['scatter', 'scattertrendline']
          # The boolean being passed lets the formatAxes function
          # know that both X and Y axis will never be MultiAxes objects
          _formatedAxes = figureService.formatAxes(figure, false)
          figureObject.xAxis = [_formatedAxes[0]]
          figureObject.yAxis = [_formatedAxes[1]]
          figureObject.zAxis = [_formatedAxes[2]]
        else if figureService.doesFigureHaveMultiYAxes(figure)
          figureObject.yAxis = figureService.formatAxes(figure, true)
        else
          figureObject.yAxis = null

      _genHighchartObject = (figure) ->
        highchartObject = figureService.getChartFromFigure(figure)
        if figureService.isTimeBasedCohortFigure(figure)
          timeInterval = figureService.getTimeInterval(figure)

          for serie in highchartObject.series
            if _.isArray(serie.name)
              strName = _.rest(serie.name.map(figureService.correctNullOrBlankValue)).join(', ')
              dateName = dateService.shortFormat(serie.name[0], timeInterval, true)
              serie.name = "#{strName}, #{dateName}"
            else
              serie.name = dateService.shortFormat(serie.name, timeInterval, true)
        
        highchartObject.chart ?=
          chart:
            type: 'line'
        
        return highchartObject

      _renderRjqlFigure = (figure) ->
        _assignAxes(figure)
        highchartObject = _genHighchartObject(figure)
        defaultObject = _genBasicOptions(highchartObject, figure, attrs.exporting)
        modifiedHighchart = _modifySeries(defaultObject, figure)
        _render(modifiedHighchart)

      _renderSqlFigure = (figure) ->
        modifiedHighchart = _modifySeries(figureService.getChartFromFigure(figure))
        _render(modifiedHighchart)

      _render = (highchart) ->
        if attrs.readyForSnapshotEvent is "true"
          highchart.chart.events ?=
            load: () ->
              # Fires when the chart is finished loading.
              scope.$emit("highchartIsReadyForTheSnapshot")

        # Destroy any existing highcharts first to prevent memory issues
        elem.highcharts()?.destroy()

        # Create a new highcharts object
        elem.highcharts(highchart)
      scope.$on "renderFigure", (event, figure) ->
        unless _.isEqual(scope.lastRendered, figure)
          scope.lastRendered = utils.copy figure
          if figure.reportQueryType is scope.reportQueryType.SQL
            _renderSqlFigure(figure)
          else
            _renderRjqlFigure(figure)

  ]